var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "div",
      { staticClass: "card-item mt-6" },
      [
        _c("h4", [
          _vm._v(" Parámetros de entrada "),
          _c(
            "button",
            {
              staticClass: "button is-button-secondary is-pulled-right",
              attrs: { id: _vm.hideParamsButtonId },
              on: { click: _vm.hideParams },
            },
            [
              _c("i", {
                staticClass: "fas",
                class: [_vm.isMenuHidden ? "fa-angle-down" : "fa-angle-up"],
              }),
            ]
          ),
        ]),
        _c("transition", { attrs: { name: "slide" } }, [
          !_vm.isMenuHidden
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "columns is-multiline is-mobile",
                    attrs: { id: "params" },
                  },
                  [
                    _c("NumberInput", {
                      attrs: {
                        id: "approvedAmount",
                        tooltip: "Monto Aprobado (con seguro)",
                        label: "Monto aprobado",
                      },
                      model: {
                        value: _vm.approvedAmount,
                        callback: function ($$v) {
                          _vm.approvedAmount = $$v
                        },
                        expression: "approvedAmount",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "termAsMonths",
                        tooltip: "Plazo en meses",
                        label: "Plazo",
                      },
                      model: {
                        value: _vm.termAsMonths,
                        callback: function ($$v) {
                          _vm.termAsMonths = $$v
                        },
                        expression: "termAsMonths",
                      },
                    }),
                    _c("DateInput", {
                      attrs: {
                        id: "startDate",
                        tooltip: "Fecha de firma / desembolso",
                        label: "Fecha de firma",
                      },
                      model: {
                        value: _vm.startDate,
                        callback: function ($$v) {
                          _vm.startDate = $$v
                        },
                        expression: "startDate",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "startOffset",
                        tooltip:
                          "Cantidad de meses que pasan desde la fecha de desembolso" +
                          " hasta que se empieza a pagar (sin considerar graces ni delays)",
                        label: "Desfase inicial",
                      },
                      model: {
                        value: _vm.startOffset,
                        callback: function ($$v) {
                          _vm.startOffset = $$v
                        },
                        expression: "startOffset",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "graceMonths",
                        tooltip:
                          "Cantidad de meses de gracia (meses al principio sin pagar pero incluyen intereses)",
                        label: "Meses de Gracia",
                      },
                      model: {
                        value: _vm.graceMonths,
                        callback: function ($$v) {
                          _vm.graceMonths = $$v
                        },
                        expression: "graceMonths",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "delayMonths",
                        tooltip:
                          "Cantidad de meses de desfase (sin ningún tipo de cobro)",
                        label: "Meses Desfase",
                      },
                      model: {
                        value: _vm.delayMonths,
                        callback: function ($$v) {
                          _vm.delayMonths = $$v
                        },
                        expression: "delayMonths",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "delayMonthsOffset",
                        tooltip:
                          "Índice (cuota 1 = índice 0) de la cuota en que se comienza a aplicar los meses de delay",
                        label: "Comienzo meses desfase",
                      },
                      model: {
                        value: _vm.delayMonthsOffset,
                        callback: function ($$v) {
                          _vm.delayMonthsOffset = $$v
                        },
                        expression: "delayMonthsOffset",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "annualRate",
                        tooltip: "Tasa anual",
                        label: "Tasa anual",
                      },
                      model: {
                        value: _vm.annualRate,
                        callback: function ($$v) {
                          _vm.annualRate = $$v
                        },
                        expression: "annualRate",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "resolution",
                        tooltip: "Decimales usados para redondear cálculos",
                        label: "Cantidad decimales",
                      },
                      model: {
                        value: _vm.resolution,
                        callback: function ($$v) {
                          _vm.resolution = $$v
                        },
                        expression: "resolution",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "payDay",
                        tooltip: "Día del mes en que se hará el pago",
                        label: "Día de pago",
                      },
                      model: {
                        value: _vm.payDay,
                        callback: function ($$v) {
                          _vm.payDay = $$v
                        },
                        expression: "payDay",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "propertyValue",
                        tooltip: "Valor de la propiedad (tasación)",
                        label: "Valor Propiedad",
                      },
                      model: {
                        value: _vm.propertyValue,
                        callback: function ($$v) {
                          _vm.propertyValue = $$v
                        },
                        expression: "propertyValue",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "lifeInsurance",
                        tooltip: "Tasa de seguro de desgravamen",
                        label: "Seguro Desgravamen",
                      },
                      model: {
                        value: _vm.lifeInsurance,
                        callback: function ($$v) {
                          _vm.lifeInsurance = $$v
                        },
                        expression: "lifeInsurance",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "fireInsurance",
                        tooltip: "Tasa de seguro de incendio y sismo",
                        label: "Seguro Incendio",
                      },
                      model: {
                        value: _vm.fireInsurance,
                        callback: function ($$v) {
                          _vm.fireInsurance = $$v
                        },
                        expression: "fireInsurance",
                      },
                    }),
                    _c("NumberInput", {
                      attrs: {
                        id: "operatingCost",
                        tooltip: "Costos de operación",
                        label: "GOP",
                      },
                      model: {
                        value: _vm.fireInsurance,
                        callback: function ($$v) {
                          _vm.fireInsurance = $$v
                        },
                        expression: "fireInsurance",
                      },
                    }),
                    _c("SelectInput", {
                      attrs: {
                        id: "capitalizationOption",
                        items: [
                          { text: "Sí", value: true },
                          { text: "No", value: false },
                        ],
                        tooltip:
                          "Sí o No. Cuando es sí, capitaliza en el monto a financiar los meses de gracia y seguros",
                        label: "Capitalizar",
                      },
                      model: {
                        value: _vm.capitalizationOption,
                        callback: function ($$v) {
                          _vm.capitalizationOption = $$v
                        },
                        expression: "capitalizationOption",
                      },
                    }),
                    _c("SelectInput", {
                      attrs: {
                        id: "numberOfAnnualDoublePayments",
                        items: [
                          { text: "No", value: 0 },
                          { text: "1 cuota", value: 1 },
                          { text: "2 cuotas", value: 2 },
                        ],
                        tooltip:
                          "0 = no / 1 = una cuota doble / 2 = dos cuotas dobles",
                        label: "Cuotas Dobles",
                      },
                      model: {
                        value: _vm.numberOfAnnualDoublePayments,
                        callback: function ($$v) {
                          _vm.numberOfAnnualDoublePayments = $$v
                        },
                        expression: "numberOfAnnualDoublePayments",
                      },
                    }),
                    _vm.numberOfAnnualDoublePayments > 0
                      ? _c("SelectInput", {
                          attrs: {
                            id: "indexOfFirstDoublePayment",
                            items: [
                              { text: "Enero", value: 0 },
                              { text: "Febrero", value: 1 },
                              { text: "Marzo", value: 2 },
                              { text: "Abril", value: 3 },
                              { text: "Mayo", value: 4 },
                              { text: "Junio", value: 5 },
                              { text: "Julio", value: 6 },
                              { text: "Agosto", value: 7 },
                              { text: "Septiembre", value: 8 },
                              { text: "Octubre", value: 9 },
                              { text: "Noviembre", value: 10 },
                              { text: "Diciembre", value: 11 },
                            ],
                            tooltip: "Índice del primer mes de cuota doble",
                            label: "1er mes doble",
                          },
                          model: {
                            value: _vm.indexOfFirstDoublePayment,
                            callback: function ($$v) {
                              _vm.indexOfFirstDoublePayment = $$v
                            },
                            expression: "indexOfFirstDoublePayment",
                          },
                        })
                      : _vm._e(),
                    _vm.numberOfAnnualDoublePayments > 1
                      ? _c("SelectInput", {
                          attrs: {
                            id: "indexOfSecondDoublePayment",
                            items: [
                              { text: "Enero", value: 0 },
                              { text: "Febrero", value: 1 },
                              { text: "Marzo", value: 2 },
                              { text: "Abril", value: 3 },
                              { text: "Mayo", value: 4 },
                              { text: "Junio", value: 5 },
                              { text: "Julio", value: 6 },
                              { text: "Agosto", value: 7 },
                              { text: "Septiembre", value: 8 },
                              { text: "Octubre", value: 9 },
                              { text: "Noviembre", value: 10 },
                              { text: "Diciembre", value: 11 },
                            ],
                            tooltip: "Índice del segundo mes de cuota doble",
                            label: "2do mes doble",
                          },
                          model: {
                            value: _vm.indexOfSecondDoublePayment,
                            callback: function ($$v) {
                              _vm.indexOfSecondDoublePayment = $$v
                            },
                            expression: "indexOfSecondDoublePayment",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                !_vm.isMenuHidden
                  ? _c("nav", { staticClass: "level" }, [
                      _c("div", { staticClass: "level-left" }),
                      _c(
                        "div",
                        { staticClass: "level-right" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "level-item is-button-secondary",
                              attrs: {
                                id: "load-default-pe-button",
                                rounded: "",
                              },
                              on: { click: _vm.setDefaultPeru },
                            },
                            [_vm._v(" Usar ejemplo Perú ")]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "level-item is-button-secondary",
                              attrs: {
                                id: "load-default-cl-button",
                                rounded: "",
                              },
                              on: { click: _vm.setDefaultChile },
                            },
                            [_vm._v(" Usar ejemplo Chile ")]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "level-item is-button-primary",
                              attrs: {
                                id: "get-amortization-schedule-button",
                                rounded: "",
                              },
                              on: { click: _vm.send },
                            },
                            [_vm._v(" Obtener Tabla de Amortización ")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }